import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

const SP_THRESHOLD = 728; // 暫定的に728以下はSP;

export const useUtilsStore = defineStore('utils', () => {
  const isOpenSidebar = ref<boolean>(false);
  const loadingCount = ref<number>(0);
  const loadingMessage = ref<string>('');
  const screenWidth = ref<number>(typeof window !== 'undefined' ? window.outerWidth : 0);
  const screenHeight = ref<number>(typeof window !== 'undefined' ? window.outerHeight : 0);

  const isLoading = computed(() => loadingCount.value > 0);

  const isSP = computed(() => screenWidth.value < SP_THRESHOLD);

  const toggleSidebar = () => {
    isOpenSidebar.value = !isOpenSidebar.value;
  };
  const incrementLoading = () => {
    loadingCount.value++;
  };
  const decrementLoading = () => {
    loadingCount.value--;
  };
  const setLoadingMessage = (message: string) => {
    loadingMessage.value = message;
  };
  const updateScreenSize = () => {
    if (typeof window !== 'undefined') {
      screenWidth.value = window.innerWidth;
      screenHeight.value = window.innerHeight;
    }
  };

  return {
    isOpenSidebar,
    isLoading,
    loadingMessage,
    isSP,
    toggleSidebar,
    incrementLoading,
    decrementLoading,
    setLoadingMessage,
    updateScreenSize
  };
});
